//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    change: function () {
      this.$emit("change");
    },
  }
}
